export const CustomMuiSnackBar = (theme: any) => {
  theme.components = {
    ...theme.components,
  };
};
